import React, { ReactNode } from 'react';

export interface IconButtonProps {
  label: string;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({
  label,
  onClick,
  children,
  className = '',
  disabled = false
}) => {
  return (
    <button
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      className={`p-2 rounded-full transition flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed ${className}`}>
      {children}
    </button>
  );
};

export default IconButton;
